// This file combines all reducers to prevent multiple imports in app.module
import { ActionReducerMap, Action } from "@ngrx/store";
import { AppState } from "../state/app.state";
import { globalHeaderReducer } from "./global-header.reducer";
import { researchGridReducer } from "./research-grid-page.reducer";
import { chartsPageReducer } from "./charts-page.reducer";
import { globalReducer } from "./global.reducer";
import { rightPanelReducer } from "./right-panel-reducer";
import { globalSubheaderReducer } from "./global-subheader-reducer";
import { companyPageReducer } from "./company-page.reducer";
import { navigationSettingsReducer } from "./navigation-settings.reducer";
import { exportToExcelReducer } from "./export-to-excel.reducer";
import { sectorIndustryReducer } from "./sector-industry.reducer";
import { globalUserSettingsReducer } from "./global-user-settings.reducer";
import { pharmaDatabasePageReducer } from "./pharma-page.reducer";
import { comparativeAnalysisReducer } from "./comparative-analysis.reducer";

export const appReducers: ActionReducerMap<AppState, Action> = {
  // add multiple reducers here
  globalHeader: globalHeaderReducer,
  researchBaseObj: researchGridReducer,
  leftPanel: globalReducer,
  rightPanel: rightPanelReducer,
  globalSubheader: globalSubheaderReducer,
  chartsPage: chartsPageReducer,
  companyPage: companyPageReducer,
  navigationSettings: navigationSettingsReducer,
  exportToExcel: exportToExcelReducer,
  pharmaDatabasePage: pharmaDatabasePageReducer,
  sectorIndustry: sectorIndustryReducer,
  globalUserSettings: globalUserSettingsReducer,
  comparativeAnalysis: comparativeAnalysisReducer,
};
